// Matches the element height to an element from the dom, which id equals to the ref input
//
// Example:
// <div class="container">
//    <div id="elementToResize"></div>
//    <div [resize]="'elementToResize'"></div>
// </div>
//
import { AfterViewChecked, Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[resize]' })
export class ResizeDirective implements AfterViewChecked {
  @Input('resize') ref: string;

  constructor(private el: ElementRef) {}

  ngAfterViewChecked(): void {
    if (this.ref) {
      const refElement = document.getElementById(this.ref);
      if (refElement) {
        this.el.nativeElement.style.height = `${refElement.scrollHeight}px`;
      }
    }
  }
}
